export default __webpack_public_path__ + "static/brand-colors-mic-annotation-light-4fcf0ca7c4a319d248300c8e2636f32e.png";